stateProviders.push({

    name: "printVoucher",
    url: "/printVoucher/:voucherID",
    templateUrl: "fast/submodules/schoolside/vouchers/printVoucher/partials/printVoucher.html?v=" + versionNo,
    controller: "PrintVoucherController",
    resolve:
    {
        voucher: function($stateParams) {
            return ($stateParams.voucherID);
        },
        school: function (SchoolModelService, authServiceFactory)
        {
            return SchoolModelService.get(authServiceFactory.getAuth().schoolID);
        }
    }

});
